export const config = {
  API_URL: "//18.224.140.113:70/",
  PROTOCOL: "http:",
  API_CLIENT_ID: "safebuilt_dev",
  API_CLIENT_SECRET: "safebuilt_dev",
  INTEGRATION_USER_EMAIL: "cc_reviewer@safebuilt.com",
  INTEGRATION_USER_PASSWORD: "cc_safecv",
  WS_URL: "wss://9uo57km877.execute-api.us-east-2.amazonaws.com/dev",
  FULL_STORY_ENABLED: false,
  PDFTRON_VISIBILITY: true,
  FEATURE_ADMIN_MULTIVERSION_CODEBOOK_ENABLED: true,
  FEATURE_SHARE_VISIBILITY_ENABLED: true,
  FEATURE_REVIEWER_SSO_ENABLED: false,
  FEATURE_GT_UPLOAD_ENABLED: true,
  FEATURE_FTS_ENABLED_FROM: 2720,
  FEATURE_HIGHLIGHT_ENABLED: true,
};
